import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    tab_container: {
        display: 'flex',
        width: "100%",
        marginTop: 10
    },
    row: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        flexWrap: 'wrap',
        gap: 8
    },
    box: {
        backgroundColor: theme.palette.common.white,
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: 4,
        padding: 16,
        minHeight: 250,
    },
    with_scroll: {
        overflowY: "auto"
    },
    with_height: {
        height: "500px",
    },
    span2: {
        gridColumn: "1 / -1",
    },
}));

export {useStyles}
